import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
const headingStyles = xcss({
  color: 'color.text.subtle',
  font: 'font.heading.xxsmall',
  paddingBlock: 'space.0',
  paddingInline: 'space.200'
});

/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */
const GroupTitle = ({
  id,
  title
}) => /*#__PURE__*/React.createElement(Box, {
  "data-ds--menu--heading-item": true,
  role: "menuitem",
  id: id,
  "aria-hidden": "true",
  xcss: headingStyles
}, title);
export default GroupTitle;